import i18next from "i18next";
import { useTranslation } from "react-i18next";

/**
 * NOTE: Better to use the hook version
 */
export function setLocale(locale: string) {
  return i18next.changeLanguage(locale);
}

export default function useSetLocale() {
  const translation = useTranslation();
  const currentLocale = translation.i18n.language;
  const setLocale = translation.i18n.changeLanguage;

  return (lng?: string | null) => {
    if (lng && lng !== currentLocale) return setLocale(lng);
    return setLocale(currentLocale);
  };
}

export function useLocale() {
  return [useTranslation().i18n.language, useSetLocale()] as const;
}
